module.exports = __webpack_public_path__ + "img/user_avatar.4cf7fa50.png";